export default __webpack_public_path__ + "static/media/bl8.45f3fe35.png";